import { EFParams, ETrips } from '@enums/api.enum';
import { EStyles } from '@enums/style.enum';
import type { TripStatus } from '@enums/trips.enum';
import type { LatLngCoordinates, Trip } from '@store/trips/tripsSlice';

import client from '../apiClient';

export type TripsParams = {
	limit?: number;
	page?: number;
	search?: string;
	sort?: string;
	fromDate: number;
	toDate: number;
	flightNumber: string[];
	status?: TripStatus[];
};

export type TripParam = {
	id: Trip['id'];
};

export interface TripApiResponse extends Trip {
	mapRoutes: {
		selectedIndex: number;
		options: LatLngCoordinates[];
	};
}

export type TripsApiResponse = {
	records: Trip[];
	totalResults: number;
	totalFiltersResults: number;
	totalPages: number;
	page: number;
};

const endpoint = ETrips.endpoint;

const get = <T>({
	limit = 200,
	page = 1,
	search = EStyles.emptyQuote,
	sort = EFParams.dateAsc,
	fromDate,
	toDate,
	status = [],
	flightNumber = [],
}: TripsParams) => {
	const statusQuery = status.length
		? status.map((s) => `${EFParams.and}${EFParams.status}${s}`).join(EStyles.emptyQuote)
		: EStyles.emptyQuote;

	const flightNumberQuery = flightNumber.length
		? flightNumber.map((f) => `${EFParams.and}${EFParams.flightNumber}${f}`).join(EStyles.emptyQuote)
		: EStyles.emptyQuote;

	const query = [
		EFParams.qm,
		EFParams.limit,
		limit,
		EFParams.and,
		EFParams.page,
		page,
		EFParams.and,
		EFParams.sort,
		sort,
		EFParams.and,
		EFParams.search,
		search,
		fromDate ? `${EFParams.and}${EFParams.fromDate}${fromDate}` : EStyles.emptyQuote,
		toDate ? `${EFParams.and}${EFParams.toDate}${toDate}` : EStyles.emptyQuote,
		flightNumberQuery,
		statusQuery,
	].join(EStyles.emptyQuote);

	return client.get<T>(`${endpoint}${query}`);
};

const getSingle = <T>({ id }: TripParam) => client.get<T>(`${endpoint}${ETrips.single}${id}`);

export default {
	get,
	getSingle,
};
